import script from "./EvseOtas.vue?vue&type=script&lang=ts&setup=true"
export * from "./EvseOtas.vue?vue&type=script&lang=ts&setup=true"

import "./EvseOtas.vue?vue&type=style&index=0&id=9b4256b2&lang=scss"

const __exports__ = script;

export default __exports__